import { render } from "./logina.vue?vue&type=template&id=c16555a4&scoped=true"
import script from "./logina.vue?vue&type=script&lang=js"
export * from "./logina.vue?vue&type=script&lang=js"

import "./logina.vue?vue&type=style&index=0&id=c16555a4&scoped=true&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16555a4"]])

export default __exports__